'use client';

import { handleRequest } from "./common";
import { websocketRequest } from "./requests";

export async function getRooms() {
  const data = await handleRequest('/chatapp/rooms', 'GET');
  return data || [];
}

export async function getRoom(roomId: string) {
  const data = await handleRequest(`/chatapp/rooms/${roomId}`, 'GET');
  return data;
}

export async function getRoomsWebsocketURL() {
  const url = websocketRequest('/chatapp/rooms/ws');
  return url;
}